import { Controller } from '@hotwired/stimulus'
import { on, off } from '../lib/events'
import { get } from '../lib/request'

export default class extends Controller {
  static values = { open: Boolean }
  static targets = ['otherCarts', 'chevron']

  connect = () => {
    this.loadContent = true
    on('openCart', this.openCart)
    if (this.cartOpener) this.cartOpener.addEventListener('click', this.openCart)
    this.samplesCartOpeners.forEach(el => el.addEventListener('click', this.openCart))
  }

  disconnect = () => {
    off('openCart', this.openCart)
    if (this.cartOpener) this.cartOpener.removeEventListener('click', this.openCart)
    this.samplesCartOpeners.forEach(el => el.removeEventListener('click', this.openCart))
  }

  openCart = () => {
    this.element.style.right = '0'
    this.openValue = true
    this.showCartContent()
  }

  closeCart = () => {
    this.element.style.right = `-${this.element.clientWidth + 50}px`
    this.openValue = false
  }

  showCartContent = () => {
    if (this.loadContent) {
      get('/cart', { responseKind: 'turbo-stream' })
      this.loadContent = false
    }
  }

  toggleOtherCarts = (event) => {
    event.preventDefault()
    const dropdown = this.otherCartsTarget
    const chevron = this.chevronTarget

    if (dropdown.classList.contains('hidden')) {
      dropdown.classList.remove('hidden')
      chevron.style.transform = 'rotate(180deg)'
    }
    else {
      dropdown.classList.add('hidden')
      chevron.style.transform = 'rotate(0deg)'
    }
  }

  get cartOpener() {
    return document.getElementById('cartOpener')
  }

  get samplesCartOpeners() {
    return document.querySelectorAll('[data-cart-opener="samples"]')
  }

  get addToCartButtonmobile() {
    return document.getElementById('addToCartButtonmobile')
  }

  get addToCartButtondesktop() {
    return document.getElementById('addToCartButtondesktop')
  }
}
